/**
 * Featured blog posts carousel functionality
 * Creates responsive sliders for blog post previews with navigation and accessibility
 * Supports multiple breakpoints and theme editor integration
 */

(async () => {

  if (!customElements.get('featured-blog-posts-swiper')) {
    
    const { default: Swiper, A11y, Navigation, Pagination, Scrollbar } = await import("swiper");
    
    Swiper.use([
      A11y,
      Navigation,
      Pagination,
      Scrollbar,
    ]);
    
    class featuredBlog extends HTMLElement {
      constructor() {
        super();
        
        this.swiperElement = this.querySelector('[data-featured-blog-posts-swiper]');
        
        this.swiperOptions = {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            640: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 3
            }
          }
        }
        
        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }
        
        this.init();
        
      }
      
      init() {
        
        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {
          
          // Update the swiper
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
          
        }
        
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
      
    }
    
    window.featuredBlog = featuredBlog;
    customElements.define('featured-blog-posts-swiper', featuredBlog);
  }
  
})();
